angular.module('eatself').component('collapseIndicator',{
	bindings: {
		open: '<',
		loading: '<',
	},
	controllerAs: 'vm',
	template: `
		<span ng-show="!vm.loading">
			<span class="fa fa-caret-right" ng-class="{ 'fa-rotate-90': vm.open }" style="vertical-align: middle; transition: transform 500ms ease-in-out"></span>
		</span>
		<i class="loading" ng-show="vm.loading" style="vertical-align: middle"></i>
	`,
})